<template>
  <div class="quiz-height-calculator">
    <div class="calculator__container">
      <div v-if="this.units.length > 1" class="calculator__units">
        <div v-for="(unit, i) in units" :key="unit.name" class="unit" :class="{unit_active: i === activeUnitIndex}" @click="activeUnitIndex = i">
          {{unit.name}}
        </div>
      </div>

      <div class="calculator__content">
        <div class="calculator__input">
          <div v-if="!activeUnit.parts" class="input__wrapper">
            <input v-model="value" type="number" :min="minCorrected" :max="maxCorrected" :maxlength="max.toString().length" :style="{maxWidth: inputLength + 'ch'}" :placeholder="placeholder" @change="validateInput">

            <div class="input__units">{{activeUnit.name}}</div>
          </div>
          <template v-else>
            <div class="input__wrapper">
              <input v-model="ft" type="number" :min="minCorrected" :max="maxCorrected" :maxlength="max.toString().length" :style="{maxWidth: inputLength + 'ch'}" :placeholder="placeholder" @change="validateFtInput">

              <div class="input__units">{{activeUnit.parts[0].name}}</div>
            </div>
            <div class="input__wrapper">
              <input v-model="inches" type="number" :min="0" :max="11" :maxlength="2" :style="{maxWidth: inputLength + 'ch'}" :placeholder="placeholder" @change="validateInchInput">

              <div class="input__units">{{activeUnit.parts[1].name}}</div>
            </div>
          </template>
        </div>

        <p v-if="!hideCaption" class="input__caption" v-html="$t('quiz.list[1].caption', {mn: minCorrected, mx: maxCorrected, nm: activeUnit.name})"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "quiz-height-calculator",

  props: {
    name: String,
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 10,
    },
    units: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
    },
    hideCaption: {
      type: Boolean,
    }
  },

  created() {
    if (this.$i18n.locale === 'ru') {
      this.activeUnitIndex = 1;
    }
  },

  computed: {
    activeUnit() {
      return this.units[this.activeUnitIndex];
    },
    inputLength() {
      const maxLength = this.maxCorrected.toString().length;
      const placeholderLength = this.placeholder.length;
      return Math.max(maxLength, placeholderLength);
    },
    minCorrected() {
      return Math.round(this.min * this.activeUnit.multiplier * 100) / 100;
    },
    maxCorrected() {
      return Math.round(this.max * this.activeUnit.multiplier * 100) / 100;
    },
  },

  data() {
    return {
      value: null,
      inches: null,
      ft: null,
      activeUnitIndex: 0,
    }
  },

  watch: {
    activeUnitIndex(newVal, oldVal) {
      this.validateInput(true, this.units[newVal].multiplier, this.units[oldVal].multiplier);
    },
    placeholder() {
      this.activeUnitIndex = 0;
      this.value = null;
    },
  },

  methods: {
    validateInput(unitsChange, newVal, oldVal) {
      if (unitsChange === true) {
        if (this.value) {
          this.value = Math.round(this.value * (newVal / oldVal));
        } else {
          return;
        }
      }

      if (this.value < this.minCorrected) {
        this.value = this.minCorrected;
      } else if (this.value > this.maxCorrected) {
        this.value = this.maxCorrected;
      }

      this.$emit("changeValue", this.value);

      if (this.activeUnitIndex === 1) {
        localStorage.setItem(this.name, this.value);
      } else {
        localStorage.setItem(this.name, Math.round(this.value * (this.units[1].multiplier / this.units[0].multiplier)));
      }
    },
    recalculateValue() {
      this.value = this.ft + ((this.inches * 100 / 12) / 100);
      localStorage.setItem(this.name, Math.round(this.value * (this.units[1].multiplier / this.units[0].multiplier)));
    },
    validateFtInput() {
      this.ft = Math.round(this.ft);

      if (this.ft < this.minCorrected) {
        this.ft = Math.round(this.minCorrected);
      } else if (this.ft > this.maxCorrected) {
        this.ft = Math.round(this.maxCorrected);
      }

      this.recalculateValue();
    },
    validateInchInput() {
      this.inches = Math.round(this.inches);

      if (this.inches < 0) {
        this.inches = 0;
      } else if (this.inches > 11) {
        this.inches = 11;
      }

      this.recalculateValue();
    },
  },
}
</script>

<style lang="sass">
.quiz-height-calculator
  .calculator__container
    display: flex
    flex-direction: column
    align-items: center
    padding: 15px 0 24px

    .calculator__content
      width: 100%

    .calculator__input
      display: flex
      position: relative
      align-items: center
      justify-content: center
      border-bottom: 1px solid rgba(191, 191, 191, 1)
      padding-bottom: 9px
      gap: 8px
      width: 100%

      .input__wrapper
        display: flex
        position: relative
        align-items: center
        justify-content: center
        flex-grow: 1

      input
        color: rgba(43, 39, 51, 1)
        font-size: 28px
        line-height: 32px
        font-weight: 500
        text-align: center
        border: none
        margin: 0
        padding: 0
        background: none
        outline: none
        width: 100%

        //&::placeholder
        //  font-size: 18px
        //  line-height: 27px

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button
          -webkit-appearance: none
          margin: 0

        &[type=number]
          -moz-appearance: textfield

      .input__units
        //position: absolute
        //right: 16px
        color: rgba(0, 0, 0, 1)
        font-size: 24px
        line-height: 24px
        text-align: center
        padding-left: 8px

    .input__caption
      font-size: 12px
      line-height: 14px
      color: rgba(43, 39, 51, 1)
      font-weight: 500
      text-align: center
      margin-top: 9px

    .calculator__units
      display: flex
      align-items: center
      justify-content: center
      background: rgba(238, 238, 238, 1)
      border-radius: 8px
      padding: 3px
      width: fit-content
      margin-bottom: 25px

      .unit
        min-width: 57px
        padding: 5px 12px
        border-radius: 5px
        transition: .3s ease
        color: rgba(0, 0, 0, 1)
        line-height: 16px
        text-align: center
        cursor: pointer

        &.unit_active
          background: rgba(251, 251, 251, 1)
</style>